type BankLogo =
    | 'baac' | 'bay' | 'bbl' | 'boc' | 'bofa' | 'cimb'
    | 'citi' | 'gh' | 'gsb' | 'hsbc' | 'icbc' | 'kbank' | 'kk'
    | 'ktb' | 'lh' | 'peer2pay'
    | 'scb' | 'sc' | 'tbank' | 'ttb'
    | 'truewallet' | 'uobt';

/** =======================
 *  🚀 50 mock withdrawers
 *  =======================*/
export const withdrawTemplates: {
    name: string;
    phone: string;
    bank: BankLogo;
}[] = [
    { name: 'เกศินี', phone: '088-XXXX-985', bank: 'kbank' },
    { name: 'จิราพร', phone: '092-XXXX-541', bank: 'scb' },
    { name: 'ธีรพงษ์', phone: '092-XXXX-643', bank: 'ktb' },
    { name: 'กาญจนา', phone: '097-XXXX-527', bank: 'bbl' },
    { name: 'ประภาศรี', phone: '082-XXXX-975', bank: 'bay' },
    { name: 'เจษฎา', phone: '092-XXXX-329', bank: 'ttb' },
    { name: 'ชนากานต์', phone: '081-XXXX-214', bank: 'gsb' },
    { name: 'นงนภัส', phone: '084-XXXX-037', bank: 'kbank' },
    { name: 'พชร', phone: '063-XXXX-411', bank: 'kbank' },
    { name: 'สุภาวดี', phone: '091-XXXX-558', bank: 'scb' },

    { name: 'ณัชชา', phone: '095-XXXX-664', bank: 'sc' },
    { name: 'ศุภกร', phone: '086-XXXX-903', bank: 'scb' },
    { name: 'วรินทร์', phone: '083-XXXX-742', bank: 'lh' },
    { name: 'ธนวัฒน์', phone: '092-XXXX-271', bank: 'baac' },
    { name: 'ณัฐมน', phone: '094-XXXX-126', bank: 'icbc' },
    { name: 'จินตนา', phone: '087-XXXX-504', bank: 'kk' },
    { name: 'อรรถพล', phone: '068-XXXX-338', bank: 'peer2pay' },
    { name: 'พิมพ์ชนก', phone: '089-XXXX-417', bank: 'scb' },
    { name: 'ลลิตา', phone: '096-XXXX-780', bank: 'truewallet' },
    { name: 'ชัชวาล', phone: '093-XXXX-615', bank: 'citi' },

    { name: 'ศศิธร', phone: '082-XXXX-922', bank: 'scb' },
    { name: 'ธนพร', phone: '090-XXXX-847', bank: 'bofa' },
    { name: 'ณัฐพงษ์', phone: '066-XXXX-334', bank: 'boc' },
    { name: 'อนุชา', phone: '091-XXXX-279', bank: 'bay' },
    { name: 'หทัยรัตน์', phone: '088-XXXX-633', bank: 'kbank' },
    { name: 'พชรพล', phone: '089-XXXX-555', bank: 'scb' },
    { name: 'สุดารัตน์', phone: '093-XXXX-423', bank: 'ktb' },
    { name: 'ชยุต', phone: '084-XXXX-301', bank: 'bbl' },
    { name: 'ปิยาภรณ์', phone: '081-XXXX-997', bank: 'bay' },
    { name: 'เขมจิรา', phone: '095-XXXX-208', bank: 'ttb' },

    { name: 'ศิรา', phone: '097-XXXX-776', bank: 'gsb' },
    { name: 'ฐิติพร', phone: '083-XXXX-149', bank: 'kbank' },
    { name: 'ปฏิภาณ', phone: '086-XXXX-048', bank: 'kbank' },
    { name: 'อิสรีย์', phone: '094-XXXX-965', bank: 'scb' },
    { name: 'พุฒิพงศ์', phone: '092-XXXX-792', bank: 'sc' },
    { name: 'รัตนากร', phone: '082-XXXX-613', bank: 'scb' },
    { name: 'แพรวา', phone: '093-XXXX-457', bank: 'lh' },
    { name: 'สุพจน์', phone: '087-XXXX-349', bank: 'baac' },
    { name: 'จุฑามาศ', phone: '090-XXXX-622', bank: 'icbc' },
    { name: 'ชนาธิป', phone: '081-XXXX-514', bank: 'kk' },

    { name: 'นิชาภา', phone: '088-XXXX-286', bank: 'peer2pay' },
    { name: 'สมพงษ์', phone: '096-XXXX-033', bank: 'scb' },
    { name: 'พรรณราย', phone: '089-XXXX-740', bank: 'truewallet' },
    { name: 'ภานุวัฒน์', phone: '066-XXXX-846', bank: 'citi' },
    { name: 'ศิวพร', phone: '094-XXXX-277', bank: 'scb' },
    { name: 'ทรงพล', phone: '083-XXXX-852', bank: 'kbank' },
    { name: 'สุทธิดา', phone: '091-XXXX-368', bank: 'boc' },
    { name: 'มณีรัตน์', phone: '087-XXXX-797', bank: 'kbank' },
    { name: 'วริศร', phone: '090-XXXX-105', bank: 'scb' },
    { name: 'ทัศพงศ์', phone: '096-XXXX-674', bank: 'ktb' },

    { name: 'ณัฏฐนิชา', phone: '082-XXXX-498', bank: 'bbl' },
    { name: 'ณัฐชนน', phone: '093-XXXX-221', bank: 'bay' },
    { name: 'สิรภพ', phone: '089-XXXX-459', bank: 'ttb' },
    { name: 'นรีกานต์', phone: '097-XXXX-905', bank: 'uobt' },
] as const;

export const userRankData1 = [
    {
        rank: {
            name: "supreme",
            point: 789142
        },
        firstName: "สุพจน์"
    },
    {
        rank: {
            name: "supreme",
            point: 721456
        },
        firstName: "ธนกร"
    },
    {
        rank: {
            name: "supreme",
            point: 689234
        },
        firstName: "ชัยณรงค์"
    },
    {
        rank: {
            name: "supreme",
            point: 654321
        },
        firstName: "สุภาพร"
    },
    {
        rank: {
            name: "supreme",
            point: 612345
        },
        firstName: "ปิยะชาติ"
    },
    {
        rank: {
            name: "supreme",
            point: 598743
        },
        firstName: "พิมพ์ใจ"
    },
    {
        rank: {
            name: "supreme",
            point: 472167
        },
        firstName: "อารีรัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 328923
        },
        firstName: "สุดารัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 267892
        },
        firstName: "นิติพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 258726
        },
        firstName: "นันทิดา"
    }
] as const;

// ... existing code ...

export const userRankData2 = [
    {
        rank: {
            name: "supreme",
            point: 695634
        },
        firstName: "วิภาวี"
    },
    {
        rank: {
            name: "supreme",
            point: 542891
        },
        firstName: "อนุชิต"
    },
    {
        rank: {
            name: "supreme",
            point: 538547
        },
        firstName: "สิริวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 493278
        },
        firstName: "พิมพ์ชนก"
    },
    {
        rank: {
            name: "supreme",
            point: 449361
        },
        firstName: "มนัสวี"
    },
    {
        rank: {
            name: "supreme",
            point: 354792
        },
        firstName: "กิตติพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 307156
        },
        firstName: "นิรมล"
    },
    {
        rank: {
            name: "supreme",
            point: 256823
        },
        firstName: "ปรีชา"
    },
    {
        rank: {
            name: "supreme",
            point: 223679
        },
        firstName: "วราภรณ์"
    },
    {
        rank: {
            name: "supreme",
            point: 211245
        },
        firstName: "สุรชัย"
    }
] as const;

export const userRankData3 = [
    {
        rank: {
            name: "supreme",
            point: 778924
        },
        firstName: "ธิดารัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 725638
        },
        firstName: "ภัทรพล"
    },
    {
        rank: {
            name: "supreme",
            point: 671492
        },
        firstName: "จริยา"
    },
    {
        rank: {
            name: "supreme",
            point: 618357
        },
        firstName: "วิชัย"
    },
    {
        rank: {
            name: "supreme",
            point: 565841
        },
        firstName: "นภาพร"
    },
    {
        rank: {
            name: "supreme",
            point: 512963
        },
        firstName: "กฤษณ์"
    },
    {
        rank: {
            name: "supreme",
            point: 469784
        },
        firstName: "รัชนี"
    },
    {
        rank: {
            name: "supreme",
            point: 426517
        },
        firstName: "ชัยวัฒน์"
    },
    {
        rank: {
            name: "supreme",
            point: 413892
        },
        firstName: "สุมิตรา"
    },
    {
        rank: {
            name: "supreme",
            point: 405163
        },
        firstName: "ธีระพงษ์"
    }
] as const;

export const userRankData4 = [
    {
        rank: {
            name: "supreme",
            point: 786543
        },
        firstName: "อรพิน"
    },
    {
        rank: {
            name: "supreme",
            point: 734296
        },
        firstName: "นพดล"
    },
    {
        rank: {
            name: "supreme",
            point: 681537
        },
        firstName: "ปทุมา"
    },
    {
        rank: {
            name: "supreme",
            point: 628419
        },
        firstName: "สมชาย"
    },
    {
        rank: {
            name: "supreme",
            point: 575832
        },
        firstName: "กัลยา"
    },
    {
        rank: {
            name: "supreme",
            point: 523647
        },
        firstName: "ธนภัทร"
    },
    {
        rank: {
            name: "supreme",
            point: 471958
        },
        firstName: "วิไลวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 429673
        },
        firstName: "ประเวศ"
    },
    {
        rank: {
            name: "supreme",
            point: 417284
        },
        firstName: "สุภาณี"
    },
    {
        rank: {
            name: "supreme",
            point: 408935
        },
        firstName: "กิตติศักดิ์"
    }
] as const;

export const userRankData5 = [
    {
        rank: {
            name: "supreme",
            point: 792815
        },
        firstName: "ชลธิชา"
    },
    {
        rank: {
            name: "supreme",
            point: 747632
        },
        firstName: "อิทธิพล"
    },
    {
        rank: {
            name: "supreme",
            point: 694827
        },
        firstName: "พรทิพย์"
    },
    {
        rank: {
            name: "supreme",
            point: 641395
        },
        firstName: "สุรศักดิ์"
    },
    {
        rank: {
            name: "supreme",
            point: 588769
        },
        firstName: "นิตยา"
    },
    {
        rank: {
            name: "supreme",
            point: 535184
        },
        firstName: "ภาณุพงศ์"
    },
    {
        rank: {
            name: "supreme",
            point: 482573
        },
        firstName: "สุจิตรา"
    },
    {
        rank: {
            name: "supreme",
            point: 439618
        },
        firstName: "วีระพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 421357
        },
        firstName: "อุบลวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 404792
        },
        firstName: "สมพร"
    }
] as const;

export const userRankData6 = [
    {
        rank: {
            name: "supreme",
            point: 769432
        },
        firstName: "ศิรินภา"
    },
    {
        rank: {
            name: "supreme",
            point: 585210
        },
        firstName: "ณัฐวุฒิ"
    },
    {
        rank: {
            name: "supreme",
            point: 452381
        },
        firstName: "ชลธิชา"
    },
    {
        rank: {
            name: "supreme",
            point: 202014
        },
        firstName: "สุพัตรา"
    },
    {
        rank: {
            name: "supreme",
            point: 169204
        },
        firstName: "ธนกฤต"
    },
    {
        rank: {
            name: "supreme",
            point: 119384
        },
        firstName: "รุ่งโรจน์"
    },
    {
        rank: {
            name: "supreme",
            point: 104500
        },
        firstName: "ณัฐชยา"
    },
    {
        rank: {
            name: "diamond",
            point: 90520
        },
        firstName: "ปัทมพร"
    },
    {
        rank: {
            name: "diamond",
            point: 76504
        },
        firstName: "ภานุวัฒน์"
    },
    {
        rank: {
            name: "diamond",
            point: 65210
        },
        firstName: "อนันต์"
    },
    {
        rank: {
            name: "diamond",
            point: 57431
        },
        firstName: "ณิชกานต์"
    },
    {
        rank: {
            name: "platinum",
            point: 49920
        },
        firstName: "ธีรภัทร"
    },
    {
        rank: {
            name: "platinum",
            point: 49780
        },
        firstName: "นริศรา"
    },
    {
        rank: {
            name: "platinum",
            point: 47210
        },
        firstName: "สุภัค"
    },
    {
        rank: {
            name: "platinum",
            point: 44852
        },
        firstName: "สิริมา"
    },
    {
        rank: {
            name: "platinum",
            point: 42167
        },
        firstName: "พชร"
    },
    {
        rank: {
            name: "platinum",
            point: 39014
        },
        firstName: "ทัศนีย์"
    },
    {
        rank: {
            name: "platinum",
            point: 37654
        },
        firstName: "อาทิตยา"
    },
    {
        rank: {
            name: "platinum",
            point: 36259
        },
        firstName: "สุพัตรา"
    },
    {
        rank: {
            name: "platinum",
            point: 33540
        },
        firstName: "เกษมศรี"
    },
    {
        rank: {
            name: "platinum",
            point: 30985
        },
        firstName: "ปิ่นมณี"
    },
    {
        rank: {
            name: "platinum",
            point: 28123
        },
        firstName: "ภัทรพล"
    },
    {
        rank: {
            name: "gold",
            point: 21899
        },
        firstName: "ชลธิชา"
    },
    {
        rank: {
            name: "gold",
            point: 21574
        },
        firstName: "จิรายุ"
    }
] as const;

export const userRankData7 = [
    {
        rank: {
            name: "supreme",
            point: 452943,
        },
        firstName: "กิตติศักดิ์",
    },
    {
        rank: {
            name: "supreme",
            point: 313870,
        },
        firstName: "พรรณวดี",
    },
    {
        rank: {
            name: "supreme",
            point: 224199,
        },
        firstName: "สิทธิชัย",
    },
    {
        rank: {
            name: "supreme",
            point: 209872,
        },
        firstName: "ณัฐนรี",
    },
    {
        rank: {
            name: "diamond",
            point: 198760,
        },
        firstName: "กาญจนา",
    },
    {
        rank: {
            name: "diamond",
            point: 157420,
        },
        firstName: "ปาริชาติ",
    },
    {
        rank: {
            name: "diamond",
            point: 129387,
        },
        firstName: "พีรพล",
    },
    {
        rank: {
            name: "diamond",
            point: 88560,
        },
        firstName: "ศศิธร",
    },
    {
        rank: {
            name: "diamond",
            point: 62344,
        },
        firstName: "ภานุเดช",
    },
    {
        rank: {
            name: "diamond",
            point: 60312,
        },
        firstName: "อารยา",
    },
    {
        rank: {
            name: "platinum",
            point: 58920,
        },
        firstName: "วีระพล",
    },
    {
        rank: {
            name: "platinum",
            point: 56789,
        },
        firstName: "จารุวรรณ",
    },
    {
        rank: {
            name: "platinum",
            point: 53421,
        },
        firstName: "ศักดา",
    },
    {
        rank: {
            name: "platinum",
            point: 49870,
        },
        firstName: "มณีรัตน์",
    },
    {
        rank: {
            name: "platinum",
            point: 46214,
        },
        firstName: "ธีระยุทธ",
    },
    {
        rank: {
            name: "platinum",
            point: 43908,
        },
        firstName: "เพ็ญนภา",
    },
    {
        rank: {
            name: "platinum",
            point: 40444,
        },
        firstName: "อริสรา",
    },
    {
        rank: {
            name: "platinum",
            point: 36123,
        },
        firstName: "วราวุธ",
    },
    {
        rank: {
            name: "platinum",
            point: 33114,
        },
        firstName: "ศิรินันท์",
    },
    {
        rank: {
            name: "platinum",
            point: 30999,
        },
        firstName: "ทรงพล",
    },
    {
        rank: {
            name: "gold",
            point: 28765,
        },
        firstName: "นภัสสร",
    },
    {
        rank: {
            name: "gold",
            point: 22238,
        },
        firstName: "ภูริณัฐ",
    }
] as const;

export const userRankData8 = [
    {
        rank: {
            name: "supreme",
            point: 342543,
        },
        firstName: "จิรัชญ์",
    },
    {
        rank: {
            name: "supreme",
            point: 323750,
        },
        firstName: "วรชาติ",
    },
    {
        rank: {
            name: "supreme",
            point: 239567,
        },
        firstName: "อนุชิต",
    },
    {
        rank: {
            name: "supreme",
            point: 224750,
        },
        firstName: "กิตติภูมิ",
    },
    {
        rank: {
            name: "diamond",
            point: 173950,
        },
        firstName: "นพดล",
    },
    {
        rank: {
            name: "diamond",
            point: 149540,
        },
        firstName: "วรินทร",
    },
    {
        rank: {
            name: "diamond",
            point: 128590,
        },
        firstName: "กฤตภาส",
    },
    {
        rank: {
            name: "diamond",
            point: 78364,
        },
        firstName: "อนันตชัย",
    },
    {
        rank: {
            name: "diamond",
            point: 65474,
        },
        firstName: "เกียรติศักดิ์",
    },
    {
        rank: {
            name: "diamond",
            point: 63958,
        },
        firstName: "ภูวเนตร",
    },
    {
        rank: {
            name: "platinum",
            point: 57394,
        },
        firstName: "ณัฐพล",
    },
    {
        rank: {
            name: "platinum",
            point: 55938,
        },
        firstName: "ปรัชญา",
    },
    {
        rank: {
            name: "platinum",
            point: 53696,
        },
        firstName: "กวินทร์",
    },
    {
        rank: {
            name: "platinum",
            point: 49173,
        },
        firstName: "ธาริน",
    },
    {
        rank: {
            name: "platinum",
            point: 46032,
        },
        firstName: "ปรเมศวร์",
    },
    {
        rank: {
            name: "platinum",
            point: 42556,
        },
        firstName: "ศิรกร",
    },
    {
        rank: {
            name: "platinum",
            point: 41405,
        },
        firstName: "อนวัช",
    },
    {
        rank: {
            name: "platinum",
            point: 34959,
        },
        firstName: "นรินทร์",
    },
    {
        rank: {
            name: "platinum",
            point: 33956,
        },
        firstName: "ธีรภัทร",
    },
    {
        rank: {
            name: "platinum",
            point: 30233,
        },
        firstName: "ภูริเดช",
    },
    {
        rank: {
            name: "gold",
            point: 28547,
        },
        firstName: "ชินดนัย",
    },
    {
        rank: {
            name: "gold",
            point: 26675,
        },
        firstName: "ปิยะพงษ์",
    }
] as const;

export const userRankData9 = [
    {
        rank: {
            name: "supreme",
            point: 1187654,
        },
        firstName: "ธัญญารัตน์",
    },
    {
        rank: {
            name: "supreme",
            point: 951238,
        },
        firstName: "ชัยณรงค์",
    },
    {
        rank: {
            name: "supreme",
            point: 923847,
        },
        firstName: "พิมพ์ชนก",
    },
    {
        rank: {
            name: "supreme",
            point: 896521,
        },
        firstName: "ธนากร",
    },
    {
        rank: {
            name: "supreme",
            point: 872193,
        },
        firstName: "สิริวิมล",
    },
    {
        rank: {
            name: "supreme",
            point: 845632,
        },
        firstName: "ภาณุพงศ์",
    },
    {
        rank: {
            name: "supreme",
            point: 819457,
        },
        firstName: "ณัฐนรี",
    },
    {
        rank: {
            name: "supreme",
            point: 792816,
        },
        firstName: "วีรพล",
    },
    {
        rank: {
            name: "supreme",
            point: 768349,
        },
        firstName: "อรพิน",
    },
    {
        rank: {
            name: "supreme",
            point: 741285,
        },
        firstName: "สุรชัย",
    },
    {
        rank: {
            name: "supreme",
            point: 715962,
        },
        firstName: "ชลธิชา",
    },
    {
        rank: {
            name: "supreme",
            point: 689437,
        },
        firstName: "ธีรพงษ์",
    },
    {
        rank: {
            name: "supreme",
            point: 662158,
        },
        firstName: "ปทุมา",
    },
    {
        rank: {
            name: "supreme",
            point: 635924,
        },
        firstName: "นิติพงษ์",
    },
    {
        rank: {
            name: "supreme",
            point: 609783,
        },
        firstName: "กัญญาณัฐ",
    },
    {
        rank: {
            name: "supreme",
            point: 582671,
        },
        firstName: "ปรัชญา",
    },
    {
        rank: {
            name: "supreme",
            point: 556249,
        },
        firstName: "วรรณวิสา",
    },
    {
        rank: {
            name: "supreme",
            point: 529814,
        },
        firstName: "อิทธิพล",
    },
    {
        rank: {
            name: "supreme",
            point: 503697,
        },
        firstName: "ศิรินภา",
    },
    {
        rank: {
            name: "supreme",
            point: 587426,
        },
        firstName: "กิตติศักดิ์",
    },
    {
        rank: {
            name: "supreme",
            point: 763189,
        },
        firstName: "นภัสวรรณ",
    },
    {
        rank: {
            name: "supreme",
            point: 928563,
        },
        firstName: "ธนพล",
    }
] as const;

export const userRankData10 = [
    {
        rank: {
            name: "supreme",
            point: 854321,
        },
        firstName: "กมลวรรณ",
    },
    {
        rank: {
            name: "supreme",
            point: 765432,
        },
        firstName: "ขวัญใจ",
    },
    {
        rank: {
            name: "supreme",
            point: 654321,
        },
        firstName: "จักรพันธ์",
    },
    {
        rank: {
            name: "supreme",
            point: 543210,
        },
        firstName: "ฉัตรชัย",
    },
    {
        rank: {
            name: "supreme",
            point: 432109,
        },
        firstName: "ชลิตา",
    },
    {
        rank: {
            name: "supreme",
            point: 321098,
        },
        firstName: "ณัฐพล",
    },
    {
        rank: {
            name: "supreme",
            point: 210987,
        },
        firstName: "ดวงกมล",
    },
    {
        rank: {
            name: "supreme",
            point: 198765,
        },
        firstName: "ถิรวัฒน์",
    },
    {
        rank: {
            name: "supreme",
            point: 187654,
        },
        firstName: "ทิพวรรณ",
    },
    {
        rank: {
            name: "supreme",
            point: 176543,
        },
        firstName: "ธนวัต",
    }
] as const;

export const userRankData11 = [
    {
        rank: {
            name: "supreme",
            point: 912345,
        },
        firstName: "นันทนา",
    },
    {
        rank: {
            name: "supreme",
            point: 823456,
        },
        firstName: "บารมี",
    },
    {
        rank: {
            name: "supreme",
            point: 734567,
        },
        firstName: "ปกรณ์",
    },
    {
        rank: {
            name: "supreme",
            point: 645678,
        },
        firstName: "ผกามาศ",
    },
    {
        rank: {
            name: "supreme",
            point: 556789,
        },
        firstName: "พงศธร",
    },
    {
        rank: {
            name: "supreme",
            point: 467890,
        },
        firstName: "ฟาริดา",
    },
    {
        rank: {
            name: "supreme",
            point: 378901,
        },
        firstName: "ภัทรวดี",
    },
    {
        rank: {
            name: "supreme",
            point: 289012,
        },
        firstName: "มงคล",
    },
    {
        rank: {
            name: "supreme",
            point: 190123,
        },
        firstName: "ยุพา",
    },
    {
        rank: {
            name: "supreme",
            point: 154321,
        },
        firstName: "รวิภา",
    }
] as const;

export const userRankData12 = [
    {
        rank: {
            name: "supreme",
            point: 888777,
        },
        firstName: "ลดาวัลย์",
    },
    {
        rank: {
            name: "supreme",
            point: 777666,
        },
        firstName: "วรพล",
    },
    {
        rank: {
            name: "supreme",
            point: 666555,
        },
        firstName: "ศรราม",
    },
    {
        rank: {
            name: "supreme",
            point: 555444,
        },
        firstName: "หทัยชนก",
    },
    {
        rank: {
            name: "supreme",
            point: 444333,
        },
        firstName: "อดิเทพ",
    },
    {
        rank: {
            name: "supreme",
            point: 333222,
        },
        firstName: "อนงค์",
    },
    {
        rank: {
            name: "supreme",
            point: 222111,
        },
        firstName: "อารยา",
    },
    {
        rank: {
            name: "supreme",
            point: 111000,
        },
        firstName: "เอกชัย",
    },
    {
        rank: {
            name: "diamond",
            point: 99888,
        },
        firstName: "กนกวรรณ",
    },
    {
        rank: {
            name: "diamond",
            point: 88777,
        },
        firstName: "ขจรศักดิ์",
    }
] as const;

export const userRankData13 = [
    {
        rank: {
            name: "supreme",
            point: 951753,
        },
        firstName: "จารุวรรณ",
    },
    {
        rank: {
            name: "supreme",
            point: 852852,
        },
        firstName: "ฉัตรมงคล",
    },
    {
        rank: {
            name: "supreme",
            point: 753951,
        },
        firstName: "ชุติมา",
    },
    {
        rank: {
            name: "supreme",
            point: 654054,
        },
        firstName: "ณัฐวดี",
    },
    {
        rank: {
            name: "supreme",
            point: 555155,
        },
        firstName: "ดนัย",
    },
    {
        rank: {
            name: "supreme",
            point: 456256,
        },
        firstName: "ถาวร",
    },
    {
        rank: {
            name: "supreme",
            point: 357357,
        },
        firstName: "ทัศนีย์",
    },
    {
        rank: {
            name: "supreme",
            point: 258458,
        },
        firstName: "ธนิก",
    },
    {
        rank: {
            name: "supreme",
            point: 159559,
        },
        firstName: "นิตยา",
    },
    {
        rank: {
            name: "diamond",
            point: 96369,
        },
        firstName: "บุญมี",
    }
] as const;

export const userRankData14 = [
    {
        rank: {
            name: "supreme",
            point: 987654,
        },
        firstName: "ปรีชา",
    },
    {
        rank: {
            name: "supreme",
            point: 876543,
        },
        firstName: "ผ่องศรี",
    },
    {
        rank: {
            name: "supreme",
            point: 765432,
        },
        firstName: "พิมพา",
    },
    {
        rank: {
            name: "supreme",
            point: 654321,
        },
        firstName: "ภานุ",
    },
    {
        rank: {
            name: "supreme",
            point: 543210,
        },
        firstName: "มยุรา",
    },
    {
        rank: {
            name: "supreme",
            point: 432109,
        },
        firstName: "ยุทธนา",
    },
    {
        rank: {
            name: "supreme",
            point: 321098,
        },
        firstName: "รัตนา",
    },
    {
        rank: {
            name: "supreme",
            point: 210987,
        },
        firstName: "ลักษณา",
    },
    {
        rank: {
            name: "supreme",
            point: 198765,
        },
        firstName: "วิชัย",
    },
    {
        rank: {
            name: "diamond",
            point: 87654,
        },
        firstName: "ศิริพร",
    }
] as const;